import { v4 as uuidv4 } from 'uuid';

/** Generate a new UUID v4 string with optional prefix */
export function generateId(prefix?: string): string {
  const id = uuidv4();
  return prefix ? `${prefix}_${id}` : id;
}

/** Get current timestamp in ISO 8601 format (high precision for updated_at) */
export function now(): string {
  return new Date().toISOString();
}
